import { DOCUMENT } from '@angular/common';
import { OptlyService } from '@optly/services/optly.service';
import { tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Inject, Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as fromOptly from '@optly/store/actions/optly.action';
import { ROUTER_NAVIGATED } from '@ngrx/router-store';

@Injectable()
export class OptlyEffects {
  constructor(
    private readonly actions$: Actions,
    public readonly route: ActivatedRoute,
    public optlyService: OptlyService,
    @Inject(DOCUMENT) private document: Document
  ) {}

  loadExperiments$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(fromOptly.loadExperiments),

        tap(({ payload }) => {
          payload.map((experiment) =>
            this.document.body.classList.add(`${experiment}`)
          );
        })
      ),
    { dispatch: false }
  );

  triggerExperiments$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(ROUTER_NAVIGATED),
        tap(() => this.optlyService.addWrapperClasses())
      ),
    { dispatch: false }
  );
}
